/** Endpoints Vernal Tag API relayés par le backend MyTag. */
export const VERNAL_ENDPOINTS = {
    register: '/user/register',
    login: '/user/login',
    bind: '/device/bind',
    unbind: '/device/unbind',
    getDeviceList: '/device/getDeviceList',
    getLocationList: '/device/getLocationList',
    refreshLocation: '/device/refreshLocation',
    refreshLocations: '/device/refreshLocations',
};
/** Numéros de device connus fournis par le fournisseur (utilisés en mock + détection). */
export const KNOWN_DEVICE_NUMS = ['1756814431069678', '1756826855831817'];
/** Centre de la zone de test (Marrakech). */
export const MOCK_CENTER = { latitude: 31.6295, longitude: -7.9811 };
export const ERROR_CODES = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    UPSTREAM_ERROR: 'UPSTREAM_ERROR',
    UPSTREAM_TIMEOUT: 'UPSTREAM_TIMEOUT',
    UPSTREAM_UNREACHABLE: 'UPSTREAM_UNREACHABLE',
    CRYPTO_KEY_MISSING: 'CRYPTO_KEY_MISSING',
    CRYPTO_KEY_INVALID: 'CRYPTO_KEY_INVALID',
    CRYPTO_ENCRYPT_FAILED: 'CRYPTO_ENCRYPT_FAILED',
    CRYPTO_DECRYPT_FAILED: 'CRYPTO_DECRYPT_FAILED',
    DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
    NOT_FOUND: 'NOT_FOUND',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
//# sourceMappingURL=constants.js.map